module.exports = require('./OtpRequestList')